module.exports = __webpack_public_path__ + "prod/20260903163609/img/experience.942f4ebf.png";